export const INT_OR_FLOAT = /^-?(0|[1-9]\d*)?.?(0|[1-9]\d*)*$/;
export const SECONDS = /^[0-9]{1,2}$/;
export const MINUTES = /^[0-9]{0,7}$/;
export const MINUTES_2 = /^([0-9]|[0-5][0-9])$/;
export const HOURS_2 = /^([0-9])|([0-1][0-9]|[2][0-3])$/;
export const COMMA_SEP_DAYS = /^((\b[1-9],?|\b[12]\d,?|3[01],?)\s?)*$/
export const COMMA_SEP_HOURS = /^(\b(([0-1][0-9]|[2][0-3]):([0-5][0-9])),?)*$/
